import { useSyncAirflowTimer } from '../hooks';

const SyncAirflowStore = () => {
  useSyncAirflowTimer();

  return null;
};

export default SyncAirflowStore;
